import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { catalogHealthViewAccessControl } from '../access-control/catalogHealthAccess.configuration'

const CatalogHealthPage = lazy(
  () =>
    import(
      /* webpackChunkName: "CatalogHealthPage" */ '../pages/catalog-health/CatalogHealthPage'
    )
)

export const catalogHealthRouter = (
  <DomainRoute route="catalog-health" accessControl={catalogHealthViewAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="catalog-health"
        component={CatalogHealthPage}
        accessControl={catalogHealthViewAccessControl}
      />
    </DashSwitch>
  </DomainRoute>
)
